import SocketChannels from '../../../../socket_server/SocketChannels';

const CHANNEL_ORDER = Object.keys(SocketChannels.MESSAGE_TYPES);

function checkChannels(channels) {
	channels.forEach((name) => {
		if(!SocketChannels.isChannel(name)) {
			throw new Error(`Not a socket channel: ${name}`);
		}
	});
}

function sameSet(first, second) {
	return first.presence === second.presence
		&& first.channels.length === second.channels.length
		&& first.channels.every((name, index) => name === second.channels[index]);
}

// The channels the one site socket listens to: the page's default plus every
// active claim (the netplay page's chats, later a site-wide match dock). Claims
// add up; releasing one drops only what no other claim or the default still
// wants. Presence is on while the default or any claim wants it.
// onChange(next, previous) runs whenever the combined set changes. Channels
// come back in SocketChannels order so equal sets compare equal.
export default function createChannelClaims(onChange) {
	let defaultClaim = { channels: [], presence: false };
	const claims = [];

	const current = () => {
		const all = [defaultClaim, ...claims];
		const wanted = new Set(all.flatMap((claim) => claim.channels));
		return {
			channels: CHANNEL_ORDER.filter((name) => wanted.has(name)),
			presence: all.some((claim) => claim.presence),
		};
	};

	const changing = (update) => {
		const previous = current();
		update();
		const next = current();
		if(!sameSet(next, previous)) {
			onChange(next, previous);
		}
	};

	const normalize = ({ channels = [], presence = false }) => {
		checkChannels(channels);
		return { channels: [...channels], presence: !!presence };
	};

	return {
		current,
		setDefault(claim) {
			const normalized = normalize(claim);
			changing(() => {
				defaultClaim = normalized;
			});
		},
		claim(claim) {
			const normalized = normalize(claim);
			changing(() => claims.push(normalized));
			return () => {
				const index = claims.indexOf(normalized);
				if(index !== -1) {
					changing(() => claims.splice(index, 1));
				}
			};
		},
	};
}
